var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my_page"},[_c('h1',{staticClass:"headline blue"},[_vm._v("Min sida")]),_c('UserData'),_vm._m(0),_c('Loader',{attrs:{"type":"component"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',[_vm._v("Vill du avsluta ditt medlemskap mejlar du till "),_c('a',{attrs:{"href":"mailto:support@liberalerna.se"}},[_vm._v("support@liberalerna.se")])])
}]

export { render, staticRenderFns }